import { useState } from 'react'
import PropTypes from 'prop-types'
import { useHistory, useRouteMatch, Link as RouterLink } from 'react-router-dom'

import {
  Box,
  Container,
  IconButton,
  Image,
  Link,
  Text,
} from '@redriverpress/system'
import Logo from 'Images/ellii-logo-rgb-yellow-bulb.svg'

import {
  resetState,
  useStudentOnboardingContext,
} from '../../context/onboardingStudentContext'
import ResetConfirmDialog from './ResetConfirmDialog'
import { STD_ONBOARDING_PATH } from '../constants'

const CloseButton = ({ onClick }) => (
  <Box
    position='sticky'
    top='0'
    display='flex'
    alignItems='center'
    width={1}
    height='76px'
    px={[0, null, 4]}
  >
    <Container width={1} display='flex' alignItems='center'>
      <IconButton onClick={onClick} icon='times' fontSize={0} ml='auto' />
    </Container>
  </Box>
)

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}

const RegularNavbar = ({ matchSignup }) => (
  <Box
    display='flex'
    alignItems='center'
    position='sticky'
    top='0'
    width={1}
    height='76px'
    background='white'
    boxShadow={1}
  >
    <Container width={1}>
      <Box
        width={1}
        display='flex'
        justifyContent='space-between'
        alignItems='center'
      >
        <RouterLink style={{ backgroundImage: 'none' }} to='/'>
          <Image alt='Ellii logo' src={Logo} height='28px' mt={1} />
        </RouterLink>
        <Text>
          Are you a teacher?{' '}
          {matchSignup ? (
            <Link href='/sign_up_options'>Sign up</Link>
          ) : (
            <Link href='/sign_in'>Log in</Link>
          )}
        </Text>
      </Box>
    </Container>
  </Box>
)

RegularNavbar.defaultProps = {
  matchSignup: null,
}

RegularNavbar.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  matchSignup: PropTypes.object,
}

export default function OnboardingNavBar() {
  const history = useHistory()
  const matchRoot = useRouteMatch({
    path: STD_ONBOARDING_PATH.root,
    exact: true,
  })
  const matchSignup = useRouteMatch({
    path: STD_ONBOARDING_PATH.signup,
    exact: true,
  })
  const matchLogin = useRouteMatch({
    path: STD_ONBOARDING_PATH.login,
  })

  const [, dispatch] = useStudentOnboardingContext()

  const [dialogOpen, setDialogOpen] = useState(false)

  const handleResetOnboarding = () => {
    setDialogOpen(false)
    dispatch(resetState())
    history.push({ pathname: STD_ONBOARDING_PATH.root })
  }

  const shouldShowCloseButton = !matchRoot && !matchSignup && !matchLogin

  if (shouldShowCloseButton) {
    return (
      <>
        <CloseButton onClick={() => setDialogOpen(true)} />
        <ResetConfirmDialog
          open={dialogOpen}
          handleOpenChange={isOpen => setDialogOpen(isOpen)}
          onCancel={() => setDialogOpen(false)}
          onConfirmOk={handleResetOnboarding}
        />
      </>
    )
  }

  return <RegularNavbar matchSignup={matchSignup} />
}
